export default "__VITE_PUBLIC_ASSET__c14308a1__"